export default class FilialeDetailRequest {
  urlPath: string
  locationRequest: boolean
  latitude: number
  longitude: number
}
